import * as React from "react";

function SvgClose(props) {
  return <svg width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><path stroke="currentColor" strokeWidth={0.5} d="M9.18 8.82l-.36.36L15.64 16l-6.82 6.82.36.36L16 16.36l6.82 6.82.36-.36L16.36 16l6.82-6.82-.36-.36L16 15.64 9.18 8.82z" opacity={0.9} /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/close_b046cf.svg";
export { SvgClose as ReactComponent };